import { render, staticRenderFns } from "./appletLink.vue?vue&type=template&id=0029800f&scoped=true"
import script from "./appletLink.vue?vue&type=script&lang=ts"
export * from "./appletLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029800f",
  null
  
)

export default component.exports